// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2ChYR","detailsBorder":"styles_detailsBorder__2umF2"};